export const FONT_SIZES = [10, 11, 12, 13, 14, 15, 16, 20, 24, 32];

export const FONT_SIZE = {
  fallback: 16,
  min: 10,
  max: 32,
} as const;
